import { createApiStore } from "./genericStore";
import { SettingDefinition } from "../types/settingDefinition";
import api from "../service/api";

export const useSettingDefinitionStore = Object.assign(
  createApiStore<SettingDefinition>("/setting-definitions"),
  {
    fetchTree: async () => {
      try {
        const res = await api.get("/setting-definitions/tree");
        return res.data;
      } catch (err) {
        console.error("Failed to fetch setting definitions tree", err);
        return [];
      }
    }
  }
);
